/**
 * @generated SignedSource<<c24fc9a96efc14d1facec298b5317e41>>
 * @relayHash e511ab8064b624e568ae6bac5100e297
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e511ab8064b624e568ae6bac5100e297

import { ConcreteRequest } from 'relay-runtime';
export type WorkWithMeQuery$variables = Record<PropertyKey, never>;
export type WorkWithMeQuery$data = {
  readonly visitor: {
    readonly userAccount: {
      readonly createdJobPostings: {
        readonly count: number;
      };
    } | null;
  };
};
export type WorkWithMeQuery = {
  response: WorkWithMeQuery$data;
  variables: WorkWithMeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": [
          "APPROVED",
          "ARCHIVED",
          "PENDING",
          "PENDING_REVISION",
          "EXPIRED",
          "PAUSED"
        ]
      }
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "UserAccountCreatedJobPostingsConnection",
  "kind": "LinkedField",
  "name": "createdJobPostings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": "createdJobPostings(filter:{\"status\":[\"APPROVED\",\"ARCHIVED\",\"PENDING\",\"PENDING_REVISION\",\"EXPIRED\",\"PAUSED\"]},first:1)"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkWithMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WorkWithMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e511ab8064b624e568ae6bac5100e297",
    "metadata": {},
    "name": "WorkWithMeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "162c763e75c8433332d21c365ea9073a";

export default node;
